import React from 'react';

import ToolbarButton from '~/components/core/Editor/MenuBar/ToolbarButton';
import DropDownIcon from '~/components/icons/editor/DropDownIcon';
import Popover from '~/components/ui/atoms/Popover';
import usePopoverState from '~/components/ui/atoms/Popover/usePopoverState';

import cn from '../../../../../Utils/cn';

import colorsDataJson from './colors.json';

export interface PopoverColorPickerProps {
  onChange?: (hexColor: string) => void;
  isEnabledFunc?: () => boolean;
  icon: React.ReactNode;
  /** Names the trigger, which shows only the icon, and the popover. */
  label: string;
}

type ColorData = {
  value: string;
  label: string;
};

const colorsData: { [key: string]: ColorData[] } = colorsDataJson;
export const WHITE = '#FFFFFF';

const PopoverColorPicker: React.FC<PopoverColorPickerProps> = ({
  isEnabledFunc = () => true,
  icon,
  onChange,
  label,
}) => {
  const { triggerProps, popoverProps, close } = usePopoverState();

  return (
    <>
      <ToolbarButton disabledHoverEffect disabled={!isEnabledFunc()} aria-label={label} {...triggerProps}>
        <div className="inline-flex items-center">
          {icon}
          <DropDownIcon className="ml-4" size={12} />
        </div>
      </ToolbarButton>
      <Popover {...popoverProps} aria-label={label} align="start">
        <div className="p-4 pb-2">
          {Object.keys(colorsData).map((colorGroupName) => {
            const colors: ColorData[] = colorsData[colorGroupName];
            return (
              <div key={colorGroupName} className="p-1 inline-block">
                {colors.map((color: ColorData) => (
                  <button
                    key={color.value}
                    aria-label={`${color.label} (${color.value})`}
                    className={cn('m-2 box-border block h-[24px] w-[24px] rounded border-none hover:opacity-70', {
                      'border-1 border-solid border-slate-700 p-0': color.value === WHITE,
                    })}
                    style={{ backgroundColor: color.value }}
                    onClick={() => {
                      onChange && onChange(color.value);
                      close();
                    }}
                  />
                ))}
              </div>
            );
          })}
        </div>
      </Popover>
    </>
  );
};

export default PopoverColorPicker;
